import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // If authentication is still loading, don't render anything yet
  if (loading) {
    return null; // Or a loading spinner
  }

  // If authentication is required (any route protected by this)
  if (!isAuthenticated) {
    // Redirect to login page, remember where they were trying to go
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If this route requires admin access and user is not authenticated or not a superuser
  // Note: We already know isAuthenticated is true here
  if (requireAdmin && (!user || !user.is_superuser)) {
    // Redirect to home page or an unauthorized page if the user is logged in but not admin
    return <Navigate to="/" replace />; // Redirecting to home
  }

  // User is authenticated and has proper permissions
  return <>{children}</>;
};

export default ProtectedRoute; 